<template>
  <div class="home">
    <div class="inpPlate">
      <div class="inp">
        <div class="plate">
          <span>车牌</span>
          <!-- <el-input
            placeholder="请输入需要优惠的车牌"
            v-model="plate"
            clearable
          >
          </el-input> -->
          <!-- <el-autocomplete
            class="inline-input"
            v-model="plate"
            :fetch-suggestions="querySearch"
            placeholder="请输入需要优惠的车牌"
            :trigger-on-focus="false"
            @select="handleSelect"
          ></el-autocomplete> -->
          <el-autocomplete
            v-model="plate"
            :fetch-suggestions="querySearch"
            placeholder="请输入车牌号码"
            @select="handleSelect"
            class="autocomplete"
            :visible="isAutocompleteVisible"
            :min="3"
            trigger-on-focus="false"
          >
            <template #item="data">
              <div class="autocomplete-item">
                {{ data.item.name }}
                <div class="description">{{ data.item.description }}</div>
              </div>
            </template>
          </el-autocomplete>
          <!-- <el-popover placement="bottom" width="400" trigger="click">
            <el-table :data="restaurants" v-if="carList">
              <el-table-column
                width="150"
                property="plate"
                label="车牌号码"
              ></el-table-column>
              <el-table-column fixed="right" label="操作" width="120">
                <template slot-scope="scope">
                  <el-button
                    @click.native.prevent="deleteRow(scope.$index, tableData)"
                    type="text"
                    size="small"
                  >
                    确认
                  </el-button>
                </template>
              </el-table-column>
            </el-table> -->
          <el-button
            type="primary"
            slot="reference"
            @click="finds()"
            icon="el-icon-search"
            >查询</el-button
          >
          <!-- </el-popover> -->

          <span style="color: red; width: 5rem; font-size: 0.2rem"></span>
          <p  v-if="!arch" style="float: right;margin: 10px 10px;color: black;">当前总免费车位：{{ shopOther.freeCount  }}，当前已使用免费车位：{{ shopOther.useCount }}</p>
        </div>
      </div>
      <el-table :data="tableData" border>
        <el-table-column
          fixed
          prop="parkId"
          label="车场编号"
          v-loading="loading"
        >
        </el-table-column>
        <el-table-column prop="plate" label="车牌号"> </el-table-column>
        <el-table-column prop="inTime" label="入场时间"> </el-table-column>
        <el-table-column prop="stopTimeStr" label="停车时长"> </el-table-column>
        <el-table-column prop="actualCharge" label="收费金额">
        </el-table-column>
        <el-table-column prop="discountVal" label="已优惠"> </el-table-column>
        <el-table-column fixed="right" label="入场图片">
          <template>
            <div class="demo-image__preview">
              <el-image
                style="width: 200px; height: 60px"
                :src="url"
                :preview-src-list="srcList"
              >
              </el-image>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="discounts" v-if="arch">
        <div
          class="ticket"
          v-for="(item, index) in shopCouponList"
          :key="item.id"
        >
          <div
            class="coupon coupon-wave-left coupon-wave-right coupon-yellow-gradient"
          >
            <div class="coupon-info coupon-info-right-dashed">
              <div class="coupon-store">{{ shopName }}</div>
              <div class="coupon-price">{{ item.name }}</div>
            </div>
            <div class="coupon-get">
              <div class="coupon-desc">{{ item.fix }}张</div>
            </div>
          </div>
          <div class="enter">
            <input type="button" value="-" @click="subtraction(index)" />
            <span @mousewheel="mousewheel(index, $event)">{{ item.fix }}</span>
            <input type="button" value="+" @click="addition(index)" />
          </div>
        </div>
        <div class="mark">
          <span>备注</span>
          <el-input
            type="text"
            placeholder="优惠券备注"
            v-model="remark"
          ></el-input>
        </div>
      </div>

      <div class="statistics">
        <p v-if="arch">
          {{ ticketTotal }}：<span class="sale"
            >{{ limit }}{{ ticketName }}</span
          >
        </p>
        <p v-if="arch">
          {{ ticketTotal == "优惠合计" ? "扣费金额" : "最大扣费金额" }}：<span
            class="debit"
            >{{ ticketTotal == "优惠合计" ? money : employ == 13?money:limit }}元</span
          >
        </p>
        <p>
          <el-button type="primary" @click="affirm" :disabled="submits"
            >确认优惠</el-button
          >
        </p>
        <p><el-button type="primary" @click="dynamic" v-if="arch">无牌车优惠</el-button></p>
      </div>

      <div class="reminder">
        <p>
          <span>提示：</span
          >无牌车优惠时，请先选择优惠券，后点击无牌车优惠按钮，待优惠二维码生成时请车主扫码进行优惠。
        </p>
      </div>
    </div>

    <div class="qrs" v-show="show">
      <span class="del" @click="del">X</span>
      <div class="poster-container" ref="imageTofile">
        <div class="poster-bg-img newbg">
          <div class="poster-bg-mask"></div>
        </div>
        <div class="poster-content">
          <div id="qrcode" ref="qrcode"></div>
        </div>
      </div>
    </div>
    
    <!-- 时间段比较弹出框 -->
    <div class="time-comparison-modal" v-if="maxLimitUnit">
      <div class="time-comparison-content">
        <div class="time-comparison-header">
          <h3>设置券效期时间</h3>
          <span class="close-btn" @click="closeTimeComparisonModal">×</span>
        </div>
        <div class="time-comparison-body">
          <div class="time-range-section">
            <div class="time-input-group">
              <label class="time-label">开始时间</label>
              <div class="time-inputs">
                <el-date-picker
                  v-model="firstTimeRange.startDate"
                  type="date"
                  placeholder="选择日期"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  @change="firstTimeRangeStartDateChange"
                >
                </el-date-picker>
                <el-time-picker
                  v-model="firstTimeRange.startTime"
                  format="HH:mm"
                  value-format="HH:mm"
                  placeholder="选择时间"
                  :disabled="checked.maxLimitUnit == 1?true:false"
                  @change="firstTimeRangeStartTimeChange"
                >
                </el-time-picker>
              </div>
            </div>
            <div class="time-input-group">
              <label class="time-label">结束时间</label>
              <div class="time-inputs">
                <el-date-picker
                  v-model="firstTimeRange.endDate"
                  type="date"
                  placeholder="选择日期"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  :disabled="checked.maxLimitUnit == 1?true:false"
                  @change="firstTimeRangeEndDateChange"
                >
                </el-date-picker>
                <el-time-picker
                  v-model="firstTimeRange.endTime"
                  format="HH:mm"
                  value-format="HH:mm"
                  :disabled="checked.maxLimitUnit == 1?true:false"
                  placeholder="选择时间"
                  @change="firstTimeRangeEndTimeChange"
                >
                </el-time-picker>
              </div>
            </div>
          </div>
        </div>
        <div class="time-comparison-footer">
          <el-button @click="closeTimeComparisonModal">取消</el-button>
          <el-button type="primary" @click="confirmTimeComparison">确定</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { util } from "../utils/global";
import QRCode from "qrcodejs2";
import html2canvas from "html2canvas";
export default {
  data() {
    return {
      plate: "", // 车牌检索框
      parkId: "",
      tableData: [],
      shopCouponList: [], // 优惠券列表
      // 停车场id
      // parkId: 0,
      // 使用的优惠卷ID
      shopCouponId: "",
      // 接收券的单位
      unit: 0,
      // 判断券的单位是否一致
      units: 0,
      // 账户余额
      balance: 0,
      // 页面中展示叠加或卷面值
      limit: 0,
      // 卷扣费金额
      money: 0,
      // 优惠描述
      ticketTotal: "优惠合计",
      // 优惠卷的使用数量
      amount: 0,
      // 判断当前商户卷是否能够进行叠加
      addconuts: 0,
      // 判断是否已经使用
      employ: 0,
      // 判断当前券的类型
      type: 0,
      // 可叠加时判断类型
      verdict: {},
      // 扣费金额
      free: "扣费（元）",
      // 券统计单位
      ticketName: "",
      // 表格加载动画
      loading: false,
      // 车辆入场图
      url: "",
      // 车辆入场大图
      srcList: [],
      // 车辆优惠备注
      remark: "",
      // 商家名称
      shopName: "",
      // 固定码参数
      placeholder: "",
      show: false,
      time: "",
      imgsrc: "",
      submits: false,
      gridData: [],
      options: [],
      carList: false,
      isAutocompleteVisible: false,
      checked: "",
      shopOther:{
        freeCount:0,
        useCount:0
      },
      // 时间比较弹出框相关
      maxLimitUnit: false,
      comparisonResult: {},
      // 受控券时间
      firstTimeRange: {
        startDate: "",
        startTime: "00:00",
        endDate: "",
        endTime: "00:00",
      },
      getExclusiveSpaceData:"",
      arch:true,
      extraMoney:"",
      // 日期选择器选项
      firstTimeRangeEndDateOptions: {
        disabledDate: (time) => {
          if (!this.firstTimeRange.startDate) return false;
          return time.getTime() < new Date(this.firstTimeRange.startDate).getTime();
        }
      },
      secondTimeRangeEndDateOptions: {
        disabledDate: (time) => {
          if (!this.secondTimeRange.startDate) return false;
          return time.getTime() < new Date(this.secondTimeRange.startDate).getTime();
        }
      },
    };
  },

  mounted() {
    this.balance = this.$store.state.balance;
    let data = JSON.parse(sessionStorage.getItem("shopData"));
    for (var i = 0; i < data.shopCouponList.length; i++) {
      data.shopCouponList[i]["num"] = 0;
      data.shopCouponList[i]["fix"] = 0;
    }
     // 调用函数时，传入new Date()参数，返回值是日期和时间
    var time = this.formatTime(new Date());
    this.firstTimeRange.startDate = time;
    this.firstTimeRange.endDate = time;
    this.parkId = data.shop.parkId;
    this.addconuts = data.shop.addCount;
    this.shopCouponList = data.shopCouponList;
    this.shopName = data.shop.name;
    if(!util.isEmpty(data.shop.extParam4)) {
      this.arch = false;
      this.queryCarNum()
    }
  },
  methods: {
    // 车辆优惠
    affirm() {
      const that = this;
      that.submits = true;
      let checked = that.checked;
      let judge = util.count(that.shopCouponList, "can");
      if (that.tableData[0] == undefined) {
        util.hint(400, "请输入要优惠的车牌号码");
        that.submits = false;
        return;
      }
      if(util.isEmpty(this.getExclusiveSpaceData)) {
        if (judge == 0) {
          util.hint(400, "请选择一张优惠券");
          that.submits = false;
          return;
        }
      
        if (checked.maxLimitUnit == 1 || checked.maxLimitUnit == 2) {
          this.calculateEndTime(that.checked, that.limit);
          this.maxLimitUnit = true;
          return false
        }
      }
      if(!util.isEmpty(this.getExclusiveSpaceData)) {
        if(this.getExclusiveSpaceData.isFree) {
            this.$confirm(this.getExclusiveSpaceData.message)
            .then((_) => {
              this.shopCouponList.forEach((item)=>{
                if(item.unit == 0) {
                  that.type = item.type;
                  that.unit = 999;
                  that.value = "0";
                  that.money = item.price;
                }
              })
              that.extraMoney = this.getExclusiveSpaceData.extraMoney
              that.present()
            })
            .catch((_) => {});
            return;
        } else {
          if(this.unit == 4) {
            util.hint(400, this.getExclusiveSpaceData.message);
            return false
          } else{
            this.$confirm(this.getExclusiveSpaceData.message)
              .then((_) => {
                that.type = this.getExclusiveSpaceData.specificCoupon.type;
                that.unit = this.getExclusiveSpaceData.specificCoupon.unit;
                that.limit = this.getExclusiveSpaceData.specificCoupon.value;
                that.money = this.getExclusiveSpaceData.specificCoupon.price;
                that.extraMoney = this.getExclusiveSpaceData.extraMoney
                this.present();
            })
            .catch((_) => {});
          }
        }
        return false
      }
      
      this.present()
    },
    querySearch(queryString, cb) {
      if (queryString.length >= 3) {
        this.isAutocompleteVisible = true;
        let list = JSON.parse(sessionStorage.getItem("shopData"));
        this.tableData = [];
        let carList = "";
        let data = {
          parkId: this.parkId,
          shopId: list.shopUser.shopId,
          plate: this.plate,
        };
        this.$axios
          .post("getCarInLikePlate", JSON.stringify(data), {
            headers: {
              "Content-Type": "application/json",
            },
          })
          .then((res) => {
            console.log(res);
            
            if (res.code == 0) {
              var data = res.data;
              if (data.length > 1) {
                this.restaurants = data;
                const results = data.filter(
                  (item) => (item.value = item.plate)
                );
                cb(results);
              } else {
                this.finds(data[0].plate);
                this.restaurants = [];
                this.carList = false;
              }
            } else {
              util.hint(res.code, res.msg);
            }
          })
          .catch(function (err) {
            that.submits = true;
          });
      } else {
        this.isAutocompleteVisible = false;
      }
    },
    handleSelect(item) {
      this.plate = item.plate;
      this.finds();
      this.isAutocompleteVisible = false;
    },
    listManage(data) {
      let newData = data;
      newData.forEach((item) => {
        item["value"] = item.plate;
      });
      return newData;
    },

    // 车辆查询
    finds(plate) {
      this.loading = true;
      let list = JSON.parse(sessionStorage.getItem("shopData"));
      this.tableData = [];
      let data = {
        parkId: this.parkId,
        shopId: list.shopUser.shopId,
        plate: !plate ? this.plate : plate,
      };
      if(!util.isEmpty(list.shop.extParam4)) {
        this.queryCarNum()
      }
      this.$axios
        .post("getCarIn", data)
        .then((res) => {
          if (res.code == 0) {
            var data = res.data;
            this.srcList = [];
            this.srcList.push(data.inPic);
            this.url =
              "https://qc-park-bucket.oss-cn-shenzhen.aliyuncs.com" +
              data.inPic.slice(0, -4) +
              "_plate" +
              data.inPic.slice(-4);
            this.tableData.push(this.infoMsg(data));
            this.loading = false;
            this.getTotalPrice()
            if(!util.isEmpty(list.shop.extParam4)){
              let extParam4 = JSON.parse(list.shop.extParam4);
              if(!util.isEmpty(extParam4.exclusiveSpace)) {
                this.getExclusiveSpace(!plate ? this.plate : plate)
              }
            }
          } else {
            util.hint(res.code, res.msg);
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    deleteRow(index, rows) {
      let newData = this.restaurants[index];
      this.finds(newData.plate);
      this.restaurants = [];
      this.carList = false;
    },
    infoMsg(data) {
      switch (data.discountType) {
        case 1:
          data.discountVal = data.discountVal + "分钟";
          break;
        case 2:
          data.discountVal = data.discountVal + "元";
          break;
        case 3:
          data.discountVal = data.discountVal * 10 + "折";
          break;
        default:
          break;
      }
      return data;
    },
    // 查询当前剩余多少车位
    queryCarNum() {
      let list = JSON.parse(sessionStorage.getItem("shopData"));
      this.tableData = [];
      let carList = "";
      let data = {
        parkId: this.parkId,
        shopId: list.shopUser.shopId,
      };
      this.$axios
        .post("getExclusiveSpaceByShopId", data, {
        })
        .then((res) => {
          console.log(res);
          if(res.code == 0) {
            this.shopOther = res.other;
          } 
        })
        .catch(function (err) {
          that.submits = true;
        });
    },
    // 无牌车优惠
    dynamic() {
      var that = this;
      let list = JSON.parse(sessionStorage.getItem("shopData"));
      let judge = util.count(that.shopCouponList, "can");
      if (judge == 0) {
        util.hint(400, "请选择一张优惠券");
        return;
      }
      if (that.money <= that.balance) {
        // 请求生成二维码参数
        let data = {
          parkId: list.shop.parkId,
          shopId: list.shopUser.shopId,
          type: that.type,
          unit: that.unit,
          value: that.unit == 999 ? "0" : that.limit,
          price: that.money,
          userId: list.shopUser.id,
          userName: list.shopUser.realname,
          remark: that.remark,
        };
        that.$axios.post("createOrder", data).then((res) => {
          if (res.data.code == 400) {
            util.hint(400, res.data.msg);
            return;
          } else {
            that.placeholder =
              "https://g.zaztservice.com/park-shop/scanQrCode?orderId=" +
              res.data.orderId;
            that.qrCode(that.placeholder);
            that.$store.dispatch("getMessageList");
          }
        });
      } else {
        util.hint(400, "余额不足，请及时充值！");
        return;
      }
    },
    mousewheel(index, e) {
      if (e.deltaY < 0) {
        this.addition(index);
      } else {
        if (this.shopCouponList[index].fix - 1 >= 0) {
          this.subtraction(index);
        }
      }
      return false;
    },
    // 卷数量的递减
    subtraction(i) {
      var arr = this.shopCouponList[i];
      var index = i;
      let array = this.shopCouponList;
      let type = arr.type;
      var timeEnd = parseInt(array[index].fix);
      timeEnd -= 1;
      if (timeEnd >= 0) {
        // 当使用了全免券进行更换时
        if (type == 4) {
          this.employ = 0;
          this.unit = "";
          this.type = 0;
          this.free = "扣费（元）";
          array[index].fix = timeEnd;
          this.getTotalPrice();
          return;
        } else {
          if (timeEnd > 0) {
            // 判断当前券不为0时进入计算
            array[index].fix = timeEnd;
            this.getTotalPrice(); // 计算合计值及金额
          } else if (timeEnd == 0) {
            // 判断当前券张数为0时
            var del = this.verdict;
            delete del[arr.name]; // 将键值对中内容进行删除
            var nums = Object.keys(this.verdict).length; // 判断键值对对象的长度
            if (nums == 0) {
              // 当键值对为 0 时代表券以全部清空，恢复原始数值得以进行后期选择
              this.employ = 0;
              this.unit = 0;
              this.units = this.units;
              this.type = 0;
              this.ticketTotal = "优惠合计";
            }
            array[index].fix = timeEnd;
            this.getTotalPrice();
          }
        }
      } else {
        util.hint(400, "使用的优惠券张数不能小于0");
      }
    },
    

    // 卷数量的递增
    addition(i) {
      // 拿到当前行数据
      var arr = this.shopCouponList[i];
      var index = i;
      let array = this.shopCouponList;
      let addNum = util.addcount(array);
      if (this.addconuts != 0 && addNum == this.addconuts) {
        util.hint(400, "最多只能使用" + this.addconuts + "张优惠券");
        return false;
      }
            // 检查maxLimitUnit字段的叠加限制
      if (this.employ !== 0) { // 如果已经有券被使用
        // 检查已使用的券中是否有maxLimitUnit不为null且当前券的maxLimitUnit为null，或当前券maxLimitUnit不为null且已使用券中有为null的
        let hasNullLimitUnit = false;
        let hasNonNullLimitUnit = false;
        let hasNonZeroLimitUnit = false;

        // 遍历已使用的券
        for (let i = 0; i < array.length; i++) {
          if (array[i].fix > 0) { // 表示这张券正在被使用
            if (array[i].maxLimitUnit === null) {
              hasNullLimitUnit = true;
            } else if (array[i].maxLimitUnit !== 0) {
              hasNonZeroLimitUnit = true;
            }
          }
        }
        
        // 如果当前券的maxLimitUnit不为null或0，且已使用券中有maxLimitUnit为null的，或反之，则不允许叠加
        if ((arr.maxLimitUnit !== 0 && arr.maxLimitUnit !== null && hasNullLimitUnit) ||
          (arr.maxLimitUnit === null && hasNonZeroLimitUnit)) {
          util.hint(400,"限制优惠时段券不可与其他券共同使用");
          return;
        }
        
        // 检查是否是同一张券的叠加
        if (arr.maxLimitUnit !== 0 && arr.maxLimitUnit !== null) {
          // 如果当前券是maxLimitUnit不为null的券，则只允许与自身叠加
          let isUsingSameCoupon = false;
          for (let i = 0; i < array.length; i++) {
            if (array[i].fix > 0 && array[i].id === arr.id) { // 使用同一张券的多个数量
              isUsingSameCoupon = true;
            } else if (array[i].fix > 0 && array[i].id !== arr.id && array[i].maxLimitUnit !== 0 && array[i].maxLimitUnit !== null) {
              // 如果已经使用了其他maxLimitUnit不为null的券，则不允许叠加
              util.hint(400,"限制优惠时段券不可与其他券共同使用");
              return;
            }
          }
        }
      }
      
      // 检查当前券是否maxLimitUnit不为null，且已使用其他券的情况
      if (arr.maxLimitUnit !== null && arr.maxLimitUnit !== 0) {
        // 检查是否已使用其他券
        for (let i = 0; i < array.length; i++) {
          if (array[i].fix > 0 && array[i].id !== arr.id) {
            // 如果已使用其他券，则不允许添加当前券
            util.hint(400, "限制优惠时段券不可与其他券共同使用");
            return;
          }
        }
      }
      let type = arr.type; // 拿到当前券的类型
      let units = this.units; // 判断是否为同种类型券
      var timeEnd = parseInt(array[index].fix); // 在页面中展示券的使用数量
      timeEnd += 1;
      let num = util.count(array, "add");
      // 使用全免券
      if (
        (type == 4 && this.employ == 0 && timeEnd == 1 && num == 0) ||
        (type == 3 && this.employ == 0) ||
        (type == 10 && this.employ == 0) ||
        (type == 13 && this.employ == 0)
      ) {
        if (type == 4) {
          let statu = JSON.parse(sessionStorage.getItem("shopData")).shop
            .isFree;
          if (statu == 2) {
            this.employ = 2;
            this.unit = 999;
            this.type = type;
            this.free = "限额（元）";
          } else {
            this.employ = 2;
            this.unit = 999;
            this.type = type;
          }
        } else if (type == 3 || type == 13) {
          this.employ = type;
          this.unit = 5;
          this.type = type;
          if(type == 13) {
            this.ticketTotal = "最大减免金额";
          }
        } else if (type == 10) {
          this.employ = 1;
          this.unit = 10;
          this.type = type;
        }
        array[index].fix = timeEnd;
        this.getTotalPrice();
      } else if (
        type != 4 &&
        this.employ != 2 &&
        type != 3 &&
        type != 13 &&
        type != 10
      ) {
        // 当前券不属于全免券且没有使用过全免券时且不为折扣券时
        if (
          this.unit == 0 ||
          (array[index].unit == units && array[index].type == this.type)
        ) {
          var tianj = this.verdict;
          tianj[arr.name] = timeEnd;
          this.employ = 1;
          this.unit = array[index].unit;
          this.verdict = tianj;
          this.units = array[index].unit;
          this.type = type;
          if (array[index].type == 12 || array[index].type == 13) {
            this.employ = 1;
            this.unit = array[index].unit;
            this.type = type;
            this.ticketTotal = "最大减免金额";
          } 
        } else {
          util.hint(400, "不同类型券不可叠加");
          return;
        }
        array[index].fix = timeEnd;
        this.checked = arr,
        this.firstTimeRange.startTime = (arr.useEndHour<10?"0"+arr.useEndHour:arr.useEndHour) +":"+ (arr.useEndMinute == 0?"00":arr.useEndMinute),
        this.firstTimeRange.endTime = (arr.useEndHour<10?"0"+arr.useEndHour:arr.useEndHour) +":"+ (arr.useEndMinute == 0?"00":arr.useEndMinute),
        this.getTotalPrice();
      } else if (type == 4 && timeEnd > 1) {
        // 第二次点击全免券时
        util.hint(400, "全免券不能叠加使用");
      } else if ((type == 3 || type == 13) && this.employ != 2) {
        util.hint(400, "折扣券不能叠加使用");
      } else if (type == 10) {
        util.hint(400, "特定收费券不能叠加使用");
      } else {
        util.hint(400, "全免券不能与其他优惠类型券叠加使用");
      }
    },

    getTotalPrice() {
      // 计算使用券的总价
      let array = this.shopCouponList; // 获取购物车列表
      let total = 0;
      let amount = 0;
      if (this.employ != 0) {
        for (let i = 0; i < array.length; i++) {
          // 循环列表得到每个数据
          // if (this.employ == 13) {
          //   amount += array[i].fix * array[i].value; // 所有合计数量
          // }
          if (this.employ != 13) {
            amount += array[i].fix * array[i].value; // 所有合计数量
            total += array[i].fix * array[i].price; // 所有价格加起来
          } else if (this.employ == 13 && array[i].fix != 0) {
            amount =  array[i].value; // 所有合计数量
            total = parseInt(array[i].remark); // 所有价格加起来
          }
        } // 最后赋值到data中渲染到页面
      }
      this.shopCouponList = array;
      this.totalMoney = total.toFixed(2);
      this.money = total.toFixed(2);
      this.limit = amount;
      this.unit = this.unit;
      var ticketName = "";
      switch (this.unit) {
        case 1:
          ticketName = "小时";
          break;
        case 2:
          ticketName = "分钟";
          break;
        case 3:
          ticketName = "天";
          break;
        case 4:
          ticketName = "元";
          break;
        case 5:
          ticketName = "折";
          break;
        case 999:
          ticketName = "全免券";
          break;
        default:
          break;
      }
      if (this.unit == 999) {
        this.limit = "";
      }
      this.ticketName = ticketName;
    },
    getExclusiveSpace(plate) {
      let list = JSON.parse(sessionStorage.getItem("shopData"));
      let data = {
        parkId: this.parkId,
        shopId: list.shopUser.shopId,
        plate: plate,
      };
      this.$axios
        .post("/getExclusiveSpace", data)
        .then((res) => {
          if (res.code == 0) {
            this.getExclusiveSpaceData = res.data;
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    del() {
      // 点击关闭二维码时
      this.$router.go(0);
    },
    qrCode(url) {
      // 点击生成图片
      let qrcode = new QRCode("qrcode", {
        width: 255, //图像宽度
        height: 255, //图像高度
        colorDark: "#000000", //前景色
        colorLight: "#ffffff", //背景色
        typeNumber: 4,
        correctLevel: QRCode.CorrectLevel.H, //容错级别 容错级别有：（1）QRCode.CorrectLevel.L （2）QRCode.CorrectLevel.M （3）QRCode.CorrectLevel.Q （4）QRCode.CorrectLevel.H
      });
      this.time = util.getDays();
      this.show = true;
      qrcode.clear(); //清除二维码
      qrcode.makeCode(url); //生成另一个新的二维码
      setTimeout(() => {
        this.toImage();
      }, 500);
    },
    toImage() {
      // 第一个参数是需要生成截图的元素,第二个是自己需要配置的参数,宽高等
      html2canvas(this.$refs.imageTofile, {
        backgroundColor: null,
      }).then((canvas) => {
        let url = canvas.toDataURL("image/png");
        this.imgsrc = url; // 把生成的base64位图片上传到服务器,生成在线图片地址
      });
    },

    // 计算当天时间
  formatTime() {
    var date1 = new Date();
    var year = date1.getFullYear();
    var month = date1.getMonth() + 1;
    var day = date1.getDate();
    if (month < 10) {
      month = "0" + month;
    }
    if (day < 10) {
      day = "0" + day
    }
    return year + "-" + month + "-" + day;
  },

  cancel() {
     // 调用函数时，传入new Date()参数，返回值是日期和时间
     var time = this.formatTime(new Date());
    this.setData({
      maxLimitUnit: false,
      startDate: time,
      endDate: time
    })
  },

  /**
   * 根据优惠券的useEndHour、value值和amount数量计算结束时间
   * @param {Object} coupon - 优惠券对象
   * @param {number} coupon.useEndHour - 优惠券结束小时（24小时制）
   * @param {number} coupon.useEndMinute - 优惠券结束分钟
   * @param {number} coupon.value - 优惠券值（小时）
   * @param {number} amount - 优惠券数量
   * @returns {string} 格式化的结束时间字符串 (yyyy-MM-dd HH:mm:ss)
   */
  calculateEndTime(coupon, amount) {
    let startTime = this.parseDate(this.firstTimeRange.startDate + " " + this.firstTimeRange.startTime)
    let startDateTime;
    // 如果提供了开始时间，则使用提供的开始时间，否则使用当前日期+useEndHour+useEndMinute
    if (startTime) {
      startDateTime = new Date(startTime);
    } else {
      // 获取当前日期
      const now = new Date();
      startDateTime = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate(),
        coupon.useEndHour,
        coupon.useEndMinute || 0, // 如果没有提供分钟，默认为0
        0,
        0
      );
    }
    let totalDurationMs = 0; // 总持续时间（毫秒）
    // 根据unit字段确定计算方式
    switch (coupon.unit) {
      case 1: // 按小时计算
        totalDurationMs = amount * 60 * 60 * 1000; // 小时 * 数量 * 3600秒 * 1000毫秒
        break;
      case 2: // 按分钟计算
        totalDurationMs = amount * 60 * 1000; // 分钟 * 数量 * 60秒 * 1000毫秒
        break;
      case 3: // 按天计算
        totalDurationMs = amount * 24 * 60 * 60 * 1000; // 天 * 数量 * 24小时 * 3600秒 * 1000毫秒
        break;
      default:
        console.warn(`未知的时间单位: ${coupon.unit}，默认按小时计算`);
        totalDurationMs = amount * 60 * 60 * 1000;
    }
    // console.log(totalDurationMs);
    // 计算结束时间（起始时间 + 总持续时间）
    const endTime = new Date(startDateTime.getTime() + totalDurationMs);
    // 格式化时间为 yyyy-MM-dd HH:mm:ss 格式
    return this.formatDateTime(endTime);
  },

  /**
   * 格式化日期时间为指定格式
   * @param {Date} date - 要格式化的日期
   * @returns {string} 格式化的日期时间字符串
   */
  formatDateTime(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    this.firstTimeRange.endDate = `${year}-${month}-${day}`;
    this.firstTimeRange.endTime = `${hours}:${minutes}`;
  },

  /**
   * 将日期字符串或Date对象转换为Date对象
   * @param {Date|string} inputDate - 输入的日期，可以是Date对象或日期字符串
   * @returns {Date|null} 有效的Date对象或null
   */
  parseDate(inputDate) {
    if (inputDate instanceof Date && !isNaN(inputDate.getTime())) {
      return inputDate;
    }
    if (typeof inputDate === 'string') {
      // 处理 "2025-12-29 14:00" 这样的格式
      const dateString = inputDate.replace(' ', 'T');
      // 如果没有秒数，添加默认的秒数
      const fullDateString = dateString.includes(':') && !dateString.includes(':ss') ?
        dateString + ':00' : dateString;
      const parsedDate = new Date(fullDateString);
      if (!isNaN(parsedDate.getTime())) {
        return parsedDate;
      }
      // 如果上面的格式不工作，尝试其他格式
      const dateWithZ = new Date(inputDate + 'Z'); // 假设为UTC时间
      if (!isNaN(dateWithZ.getTime())) {
        return dateWithZ;
      }
      // 尝试手动解析 "YYYY-MM-DD HH:mm" 格式
      const match = inputDate.match(/^(\d{4})-(\d{1,2})-(\d{1,2})\s+(\d{1,2}):(\d{2})$/);
      if (match) {
        const [, year, month, day, hour, minute] = match;
        const date = new Date(year, month - 1, day, hour, minute);
        if (!isNaN(date.getTime())) {
          return date;
        }
      }
    }
    return null;
  },

   /**
   * 比较两个时间段的时长是否一致
   */
  compareDuration() {
    let that = this;
    let startTime =this.firstTimeRange.startDate + " " +this.firstTimeRange.startTime;
    let endTime =this.firstTimeRange.endDate + " " +this.firstTimeRange.endTime;
    let coupon =this.checked;
    let amount =this.limit;
    const parsedStartTime = that.parseDate(startTime);
    const parsedEndTime = that.parseDate(endTime);

    if (!parsedStartTime || !parsedEndTime) {
      throw new Error(`时间段包含无效时间: ${startTime} 到 ${endTime}`);
    }

    // 计算第一个时间段的时长（毫秒）
    const duration1 = parsedEndTime.getTime() - parsedStartTime.getTime();

    // 根据unit和amount计算第二个时间段的时长（毫秒）
    let duration2 = 0;
    switch (coupon.unit) {
      case 1: // 按小时计算
        duration2 = amount * 60 * 60 * 1000;
        break;
      case 2: // 按分钟计算
        duration2 = amount * 60 * 1000;
        break;
      case 3: // 按天计算
        duration2 = amount * 24 * 60 * 60 * 1000;
        break;
      default:
        console.warn(`未知的时间单位: ${coupon.unit}，默认按小时计算`);
        duration2 = amount * 60 * 60 * 1000;
    }

    // 比较两个时长
    let comparisonText = '';
    if (duration1 > duration2) {
      comparisonText = 1; // 选择时段大于券时段
    } else if (duration1 < duration2) {
      comparisonText = -1; // 选择时段小于券时段
    } else {
      comparisonText = 0; // 选择时段等于券时段
    }
    // 比较两个时长
    return comparisonText
  },

  // 显示时间段比较弹出框
  maxLimitUnit() {
    this.maxLimitUnit = true;
    // 初始化时间段数据
    this.firstTimeRange = {
      startDate: this.formatDate(new Date()),
      startTime: "00:00",
      endDate: this.formatDate(new Date()),
      endTime: "23:59",
    };
  },

  // 关闭时间段比较弹出框
  closeTimeComparisonModal() {
    this.maxLimitUnit = false;
    this.submits = false;
    this.firstTimeRange = {
      startDate: this.formatDate(new Date()),
      startTime: "00:00",
      endDate: this.formatDate(new Date()),
      endTime: "23:59",
    };
  },

  // 确认时间段比较弹出框
  confirmTimeComparison() {
    //  submits() {
    if (this.compareDuration() == 1) {
      util.hint(400,"选择时间超出券合计时间，请修改");
      return false
    }
    this.maxLimitUnit = false;
    this.present()
  },

  present(){
    let that = this;
    let checked = that.checked;
    let list = JSON.parse(sessionStorage.getItem("shopData"));
    if (that.money <= that.balance) {
      let data = {
        parkId: list.shop.parkId,
        shopId: list.shopUser.shopId,
        type: that.type,
        unit: that.unit,
        value: that.unit == 999 ? "0" : that.limit,
        price: that.money,
        userId: list.shopUser.id,
        userName: list.shopUser.realname,
        remark: that.remark,
        recordId: that.tableData[0].id,
        couponId: checked.maxLimitUnit != 0 ? checked.id : "",
        useStartTime: checked.maxLimitUnit != 0 ? that.firstTimeRange.startDate + " " + that.firstTimeRange.startTime + ":00" : "",
        useEndTime: checked.maxLimitUnit != 0 ? that.firstTimeRange.endDate + " " + that.firstTimeRange.endTime + ":59" : "",
        extraMoney:this.extraMoney
      };
      that.$axios.post("confirmOrder", data).then((res) => {
        if (res.code == 0) {
          util.hint(res.code, "车辆优惠成功！");
          that.$store.dispatch("getMessageList");
        } else if (res.code == 400) {
          util.hint(res.code, res.msg);
        } else {
          util.hint("余额不足，请及时充值！", "none", 1500);
          return;
        }
        setTimeout(function () {
          that.$router.go(0);
        }, 2000);
      }).catch((err) => {
        console.log(err);
        
      });
    } else {
      util.hint(400, "余额不足，请及时充值！");
      return;
    }
  },
  
  // 格式化日期为 YYYY-MM-DD 格式
  formatDate(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  },
  
  // 受控券开始日期
  firstTimeRangeStartDateChange(val) {
    this.firstTimeRange.startDate = val;
    this.calculateEndTime(this.checked, this.limit)
  },
  
 // 受控券开始时间
  firstTimeRangeStartTimeChange(val) {
    this.firstTimeRange.startTime = val;
    this.calculateEndTime(this.checked, this.limit)
  },
  
  // 受控券结束日期
  firstTimeRangeEndDateChange(val) {
    this.firstTimeRange.endDate = val;
  },
  
  // 受控券结束时间
  firstTimeRangeEndTimeChange(val) {
    this.firstTimeRange.endTime = val;
  },

  },
  watch: {
    // watch 可以监听 data 数据 也可以监听 全局 vuex数据
    //监听vuex中userNumber的变化
    "$store.state.balance"(val) {
      this.balance = val;
    },
  },
};
</script>

<style lang="less" scoped>
@import url(../assets/css/qrCode.css);
@import url(../assets/css/carserve/car.css);
.qrs {
  padding-top: 2rem !important;
  box-sizing: border-box;
}

.poster-bg-img {
  width: 500px;
  height: 656px;
  background: url("../assets/noPlates.jpg") no-repeat;
  background-size: 100%;
}

#qrcode {
  width: 90px;
  height: 90px;
  position: absolute;
  top: 181px;
  left: 122px;
  background-color: #fff;
}

.poster-qrcode-canvas {
  width: 290px;
  height: 290px;
}

.time-comparison-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 20;
}

.time-comparison-content {
  background: white;
  border-radius: 8px;
  width: 600px;
  max-width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  position: relative;
}

.time-comparison-header {
  padding: 15px 20px;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.time-comparison-header h3 {
  margin: 0;
  color: #333;
}

.close-btn {
  font-size: 24px;
  cursor: pointer;
  color: #aaa;
  line-height: 1;
}

.close-btn:hover {
  color: #666;
}

.time-comparison-body {
  padding: 20px;
}

.time-range-section h4 {
  margin-top: 0;
  margin-bottom: 15px;
  color: #333;
}

.time-input-group {
  margin-bottom: 15px;
}

.time-label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
  color: #666;
}

.time-inputs {
  display: flex;
  gap: 10px;
  align-items: center;
}

.time-inputs .el-date-editor,
.time-inputs .el-time-picker {
  flex: 1;
}

.time-comparison-footer {
  padding: 15px 20px;
  border-top: 1px solid #eee;
  text-align: right;
}

.time-comparison-footer .el-button {
  margin-left: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/carSeve.vue